import gql from 'graphql-tag';

export const GET_SLOT_AVAILABILITIES = gql`
  query getSlotAvailabilities(
    $countryCode: String!
    $zipCode: String!
    $carrierMethod: String!
    $isFresh: Boolean!
    $isUltraFresh: Boolean!
  ) {
    getSlotAvailabilities(
      countryCode: $countryCode
      zipCode: $zipCode
      carrierMethod: $carrierMethod
      isFresh: $isFresh
      isUltraFresh: $isUltraFresh
    ) {
      date
      slots {
        value
        availableCapacity
      }
    }
  }
`;

export const GET_SLOT_AVAILABILITIES_V2 = gql`
  query getSlotAvailabilitiesV2(
    $checkoutToken: String!
    $carrierMethod: String!
    $isFresh: Boolean!
    $isUltraFresh: Boolean!
  ) {
    getSlotAvailabilitiesV2(
      checkoutToken: $checkoutToken
      carrierMethod: $carrierMethod
      isFresh: $isFresh
      isUltraFresh: $isUltraFresh
    ) {
      date
      slots {
        id
        value
        availableCapacity
      }
    }
  }
`;
